export default {
  state: {
    passwordInfos: [],
    passwordStep: "SendEmail",
    modalStatus: false,
  },

  getters: {
    getPasswordInfos(state) {
      return {
        data: state.passwordInfos,
        step: state.passwordStep,
      };
    },
    getPasswordModalStatus: (state) => state.modalStatus,
  },

  mutations: {
    setPasswordInfos(state, infos) {
      if (infos.data !== undefined) {
        infos.data !== null
          ? state.passwordInfos.push(infos.data)
          : (state.passwordInfos = []);
      }

      state.passwordStep = infos.step;
    },
    setPasswordModalStatus(state, status) {
      state.modalStatus = status;
    },
  },

  actions: {
    changePasswordInfos(context, infos) {
      context.commit("setPasswordInfos", infos);
    },
    changePasswordModalStatus(context, status) {
      context.commit("setPasswordModalStatus", status);
    },
  },
};
